<template>
    <base-input
            :error="error">
        <vue-tel-input
                :value="number"
                @onInput="updateNumber($event)"
                class="form-control"
                style="display: inline-flex; max-width:190px;"
                name="phoneNumber"
                required
                v-validate="'required'"
                disabledFetchingCountry
                defaultCountry="BE"
                data-vv-as="Phone Number"

                :preferredCountries="['be', 'us', 'gb', ]">
        </vue-tel-input>
        <base-button
                size="sm"
                icon
                type="danger"
                style="margin-top:-3px;"
                class="ml-2"
                @click.native="removeNumber()">
            <font-awesome-icon :icon="['fal','trash']"></font-awesome-icon>
        </base-button>
        <template slot="error">
            <span class="error" style="display: block;">{{ error }}</span>
        </template>
    </base-input>
</template>

<script>
    import VueTelInput from 'vue-tel-input'
    import 'vue-tel-input/dist/vue-tel-input.css';

    export default {
        name: "PhoneNumberSelectorInput",
        components: {
            VueTelInput,
        },
        props: {
            number: String,
        },
        data() {
            return {
                error: null,
            }
        },
        methods: {
            updateNumber({number, isValid, country}) {
                if (!isValid) {
                    this.error = 'Invalid Number!';
                    return;
                }
                this.error = null;
                this.$emit('update', {number})
            },
            removeNumber() {
                let number = this.number;
                this.$emit('remove', {number})
            },
        },
    }
</script>

<style scoped>

</style>